import { Route } from "@angular/router";
import { StartupGuard } from "@core/guard/startup.guard";
import { AuthLayoutComponent } from "@layout/auth-layout/auth-layout.component";
import { LandingPageComponent } from "./landing-page/landing-page.component";
import { Page404Component } from "./sessions/page404/page404.component";
import { StartupComponent } from "./startup/startup.component";
import { DataLimitReachedComponent } from "./sessions/data-limit-reached/data-limit-reached.component";

export const APP_ROUTE: Route[] = [
  {
    path: "404",
    component: Page404Component,
  },

  //Get store details
  {
    path: "pep",
    component: StartupComponent,
  },
  {
    path: "ackermans",
    component: StartupComponent,
  },
  {
    path: "dunns",
    component: StartupComponent,
  },

  //Can only access if store details are in state

  {
    path: "landing",
    component: LandingPageComponent,
    canActivate: [StartupGuard],
  },

  {
    path: "data-limit",
    component: DataLimitReachedComponent,
  },

  {
    path: "auth",
    component: AuthLayoutComponent,
    canActivate: [StartupGuard],
    loadChildren: () =>
      import("./sessions/sessions.routes").then((m) => m.SESSION_ROUTE),
  },

  //not found
  {
    path: "**",
    component: Page404Component,
  },
];
